var render = function render(){
  var _vm$summaryData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_c('div', [_vm._v(" Príjem "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.summaryData.clientInfo.type.toLowerCase()) + "a")]), _vm._v(" zo "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v("živnosti")])]), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'typ príjmu',
      "value": _vm.summaryData.typ
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'druh príjmu',
      "value": 'Živnosť'
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'mesačný príjem',
      "value": _vm.summaryData.dti.extra.prijem_mo
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obchodný názov',
      "value": _vm.summaryData.zamestnavatel.name
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ičo',
      "value": _vm.summaryData.zamestnavatel.ico
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obec',
      "value": _vm.summaryData.zamestnavatel.address_city
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ulica',
      "value": _vm.summaryData.zamestnavatel.address_street
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'súpisné číslo',
      "value": _vm.summaryData.zamestnavatel.address_popisne
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'orientačné číslo',
      "value": _vm.summaryData.zamestnavatel.address_number
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'PSČ',
      "value": _vm.summaryData.zamestnavatel.address_zip
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'email. zamestn',
      "value": _vm.summaryData.zamestnavatel.email
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'telefon zamestn',
      "value": _vm.summaryData.zamestnavatel.telefon
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'odvetvie',
      "value": _vm.summaryData.zamestnavatel_odvetvie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'komora',
      "value": _vm.summaryData.komora
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'podnikám od',
      "value": _vm.transformDate(_vm.summaryData.zamestnanie_od)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'základ z dane z príjmu',
      "value": (_vm$summaryData = _vm.summaryData) === null || _vm$summaryData === void 0 ? void 0 : _vm$summaryData.taxBase
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'daň z príjmu',
      "value": _vm.summaryData.dan_z_prijmu
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obrat',
      "value": _vm.summaryData.minulorocny_obrat
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }